export default {
  methods: {
    focusNext (enterKeyEnabled, isMortgage, deviceType) {
      if (enterKeyEnabled && !isMortgage) {
        const focusableElements = Array.from(
          document.querySelectorAll(
            'input, textarea'
          )
        ).filter(el => !el.disabled && el.offsetParent !== null)
        const currentElement = document.activeElement
        const currentIndex = focusableElements.indexOf(currentElement)

        const isLastElement = currentIndex === focusableElements.length - 1
        if (isLastElement) {
          const continueButton = document.querySelector('#app-button')
          if (continueButton) {
            continueButton.click()
          }
        } else if (currentIndex > -1 && deviceType !== 'd') {
          focusableElements[currentIndex + 1].focus()
        }
      }
    }
  }
}
